import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { KycItem, PartnerKycStatus } from '../../constants/kyc';

export interface KycQueueSubmittedItem {
  item: KycItem;
  submitted_at: string;
}

export interface KycQueueRow {
  partner_id: string;
  name: string;
  mobile: string;
  submitted_items: KycQueueSubmittedItem[];
  oldest_submitted_at: string | null;
  possible_duplicate: boolean;
  has_available_commission: boolean;
  kyc_status: PartnerKycStatus;
  payout_ready: boolean;
}

export interface KycQueueState {
  items: KycQueueRow[];
  total: number;
  limit: number;
  offset: number;
  loading: boolean;
  error: string | null;
}

const initialState: KycQueueState = {
  items: [],
  total: 0,
  limit: 50,
  offset: 0,
  loading: false,
  error: null,
};

const kycQueueSlice = createSlice({
  name: 'kycQueue',
  initialState,
  reducers: {
    setKycQueueLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setKycQueueError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
    },
    setKycQueuePage: (
      state,
      action: PayloadAction<{ items: KycQueueRow[]; total: number; limit: number; offset: number }>
    ) => {
      const { items, total, limit, offset } = action.payload;
      state.items = items;
      state.total = total;
      state.limit = limit;
      state.offset = offset;
    },
  },
});

export const { setKycQueueLoading, setKycQueueError, setKycQueuePage } = kycQueueSlice.actions;

export default kycQueueSlice.reducer;
